module.exports = __webpack_public_path__ + "img/huace8.d7236f9c.jpg";